'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _biLoggerFactory = require('wix-bi-logger-client/dist/bi-logger-factory');

var _biLoggerFactory2 = _interopRequireDefault(_biLoggerFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addParam(url, key, value) {
  var separator = url.indexOf('?') === -1 ? '?' : '&';
  return '' + url + separator + encodeURIComponent(key) + '=' + encodeURIComponent(value);
}

function buildUrl(host, endpoint, params) {
  params._ = new Date().getTime();
  var prefix = '//' + host + '/' + endpoint;
  return Object.keys(params).reduce(function (url, key) {
    return addParam(url, key, params[key]);
  }, prefix);
}

function browserLogger(opts) {
  var options = opts || {};
  return function (params, context) {
    return new Promise(function (resolve, reject) {
      var biImage = context && context.image || new Image(0, 0);
      biImage.onload = resolve;
      biImage.onerror = reject;
      biImage.src = buildUrl(options.host || 'frog.wix.com', options.endpoint || '', params);
    });
  };
}

exports.default = { factory: function factory(x) {
    return new _biLoggerFactory2.default().addPublisher(browserLogger(x));
  } };
//# sourceMappingURL=logger.js.map



//////////////////
// WEBPACK FOOTER
// ../~/web-bi-logger/dist/src/logger.js
// module id = 862
// module chunks = 0